import React from 'react';

import SelectItem from './../selects/SelectItem';
import SelectMaterial from './../selects/SelectMaterial';
import { colorStand } from '../../utils/colors';

export default class ModalStand extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validFields: {
                width: false,
                height: false,
                depth: false,
                material: false,
                color: false,
                positions: false,
                secondMaterial: false,
                secondColor: false,
            },
            options: {
                width: [],
                height: [],
                depth: [],
                material: [],
                color: [],
                positions: [],
                secondMaterial: [],
                secondColor: [],
            },
            currentOptions: {
                width: '',
                height: '',
                depth: '',
                material: '',
                color: '',
                positions: '',
                secondMaterial: '',
                secondColor: '',
            }
        }
    }

    componentDidMount() {
        this._initParameters(this.props.currentStandList);   
    }

    componentDidUpdate(prevProst, prevState) {
        if(JSON.stringify(prevState.currentOptions) !== JSON.stringify(this.state.currentOptions)) {
            this._validateFields();
            const filterStands = this._searchStand();
            if(filterStands.length === 1 && this.state.currentOptions.material) {
                this.props.updatePrice(filterStands[0].material[this.state.currentOptions.material].price);
            }
        }
    }

    _validateFields() {
        const copyValidateObject = JSON.parse(JSON.stringify(this.state.validFields));
        const currentOptions = this.state.currentOptions;
        for(let key in currentOptions) {
            if(currentOptions[key]!=='') {
                copyValidateObject[key] = true;
            }
            else {
                copyValidateObject[key] = false;
            }
        }
        
        let checkAllValidate = true;

        for(let key in copyValidateObject) {
            if(copyValidateObject[key] === false) {
                checkAllValidate = false;
            }
        }

        if(checkAllValidate) this.props.updateValidate('stand', true);
        else this.props.updateValidate('stand', false);
        
        this.setState(state => {
            return {
                validFields: copyValidateObject
            }
        })
    }

    _fieldsManager() {
        const filterArray = this.props.currentStandList.filter(stand => {
            const checkWidth = stand.width === this.state.currentOptions.width || this.state.currentOptions.width === '' || this.state.currentOptions.width === undefined;
            const checkHeight = stand.height === this.state.currentOptions.height || this.state.currentOptions.height === '' || this.state.currentOptions.height === undefined;
            const checkDepth = stand.depth === this.state.currentOptions.depth || this.state.currentOptions.depth === '' || this.state.currentOptions.depth === undefined;
            return checkWidth && checkHeight && checkDepth;
        })
        this._initParameters(filterArray);
    }

    _initParameters(stands) {
        const uniqueHeights = [];
        const uniqueDepths = [];
        const uniqueWidths = [];
        const positions = this.props.variableOptions.positions === true ? [
            {
                label: 'Слева',
                value: 'L',
            }, 
            {
                label: 'Справа',
                value: 'R',
            }
        ] : [];

        stands.forEach(currentStand => {
            const uniqueWidth = uniqueWidths.find((width) => {
                return width.value === currentStand.width
            })

            const uniqueHeight = uniqueHeights.find((height) => {
                return height.value === currentStand.height
            })

            const uniqueDepth = uniqueDepths.find((depth) => {
                return depth.value === currentStand.depth
            })
            
            if(!uniqueHeight) {
                uniqueHeights.push(
                {
                    value: currentStand.height,
                    label: `${currentStand.height} мм`
                });
            }

            if(!uniqueDepth) {
                uniqueDepths.push(
                {
                    value: currentStand.depth,
                    label: `${currentStand.depth} мм`
                });
            }
            
            if(!uniqueWidth) {
                uniqueWidths.push(
                {
                    value: currentStand.width,
                    label: `${currentStand.width} мм`
                });
            }

        }); 
        const newOptions = {...this.state.options};
        newOptions.width = [...uniqueWidths];
        newOptions.height = [...uniqueHeights];
        newOptions.depth = [...uniqueDepths];
        newOptions.material = this._initMaterial(stands);
        newOptions.positions = [...positions]

        if(this.state.currentOptions.material) {
            newOptions.color = this._initColor(this.state.currentOptions.material);
        }

        const secondMaterial = this.props.variableOptions.bicolor === true ? this._initMaterial(stands) : [];
        
        if(this.state.currentOptions.secondMaterial) {
            newOptions.secondColor = this._initColor(this.state.currentOptions.secondMaterial);
        }

        newOptions.secondMaterial = [...secondMaterial];

        if(newOptions.positions.length === 0) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.positions = false;
            this.setState((state) => {
                return {
                    currentOptions: options,
                }
            })
        }


        if(newOptions.secondMaterial.length === 0) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.secondMaterial = false;
            options.secondColor = false;
            this.setState((state) => {
                return {
                    currentOptions: options,
                }
            })
        }

        if(newOptions.secondMaterial.length === 0 && newOptions.positions.length === 0) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.secondMaterial = false;
            options.secondColor = false;
            options.positions = false;
            this.setState((state) => {
                return {
                    currentOptions: options,
                }
            })
        }

        this.setState((state) => {
            return {
                options: newOptions
            }
        })
    }

    _initColor(material) {
        let colors = [];
        let colorsOptions = []
        for(let key in colorStand) {
            if(key === material) {
                colors = colorStand[key][0].colors;
            }
        }
        colors.forEach(color => {
            colorsOptions.push({
                value: color.color,
                label: <div><span>{`${color.name}`}</span><img src={color.img}/></div>
            })
        })
        return colorsOptions;
    }


    _initMaterial(stands) {
        const materials = [];
        const standItem = stands[0].material;
        for(let key in standItem) {
            if(standItem[key].price !== false && standItem[key].price !== 0) {
                materials.push(key)
            }
        }
        const options = [];
        materials.forEach(material => {
            for(let key in colorStand) {
                if(key === material) {
                    options.push({
                        value: key,
                        label: <div><span>{`${colorStand[key][0].name}`}</span><img src={colorStand[key][0].img}/></div>
                    })
                }
            }
        })
        return options;
    }

    setWidth(value) {
        if(value || value === '') {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.width = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
        
    }

    setHeight(value) {
        if(value || value === '') {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.height = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
        
    }

    setDepth(value) {
        if(value || value === '') {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.depth = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
        
    }

    setMaterial(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.material = value.value;
            options.color = '';
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
        
    }

    setColor(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.color = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            })
        }
    }

    setSecondMaterial(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.secondMaterial = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            }, () => this._fieldsManager());
        }
    }

    setSecondColor(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.secondColor = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            })
        }
    }

    setPosition(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.positions = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            })
        }
    }

    _searchStand() {
        const currentStand = this.props.currentStandList.filter(stand => {
            return stand.width === this.state.currentOptions.width && stand.height === this.state.currentOptions.height && stand.depth === this.state.currentOptions.depth
        })
        return currentStand;
    }

    setStand() {
        const stand = this._searchStand();
        const configurations = JSON.parse(JSON.stringify(this.props.srcConfig))
        configurations.sink = false;
        configurations.tabletop = false;
        configurations.cabinet = false;
        configurations.stand = {
            color: this.state.currentOptions.color,
            material: this.state.currentOptions.material,
            article: stand[0].code,
            id: stand[0].fileName,
            position: this.state.currentOptions.positions,
            secondMaterial: this.state.currentOptions.secondMaterial,
            secondColor: this.state.currentOptions.secondColor
        }
        this.props.setConfiguration(configurations);
    }
    
    render() {
        return (
            <>
                <div className='modal-window__controls'>
                    {window.innerWidth >= 1200  ? '' : <h2 className='modal-window__controls-title'>Выберите параметры:</h2>}
                    <div className='modal-window__controls-size-group'>
                        <SelectItem handleChange = {this.setWidth.bind(this)} validate={this.props.validateParts ? this.state.validFields.width : true} options = {this.state.options.width} placeholder={'Ширина'}/>
                        <SelectItem handleChange = {this.setHeight.bind(this)} validate={this.props.validateParts ?this.state.validFields.height : true} options = {this.state.options.height} placeholder={'Высота'}/>
                        <SelectItem handleChange = {this.setDepth.bind(this)} validate={this.props.validateParts ? this.state.validFields.depth : true} options = {this.state.options.depth} placeholder={'Глубина'}/>
                        {
                            this.state.options.positions.length === 0 ?
                            <div className='modal-window__control-view-group'>
                                <div className='modal-window__control'>
                                    <SelectMaterial handleChange = {this.setMaterial.bind(this)} validate={this.props.validateParts ? this.state.validFields.material : true} options = {this.state.options.material} placeholder={'Материал'}/>
                                </div>
                                <div className={`modal-window__control ${this.state.currentOptions.material === '' ? 'modal-window__control--disabled' : ''} `}>
                                    <SelectMaterial name ="color" handleChange = {this.setColor.bind(this)} validate={this.props.validateParts ? this.state.validFields.color : true} options = {this.state.options.color} placeholder={'Цвет'}/>
                                </div>
                            </div>
                            :
                            <></>
                        }
                    </div>
                </div>
                
                {
                    this.state.options.positions.length > 0 ?
                    <div className='modal-window__controls'>
                        <div className='modal-window__control-view-group'>
                            <div className='modal-window__control'>
                                <SelectMaterial handleChange = {this.setMaterial.bind(this)} validate={this.props.validateParts ? this.state.validFields.material : true} options = {this.state.options.material} placeholder={'Материал'}/>
                            </div>
                            <div className={`modal-window__control ${this.state.currentOptions.material === '' ? 'modal-window__control--disabled' : ''} `}>
                                <SelectMaterial name ="color" handleChange = {this.setColor.bind(this)} validate={this.props.validateParts ? this.state.validFields.color : true} options = {this.state.options.color} placeholder={'Цвет'}/>
                            </div>
                        </div>
                        <div className={`modal-window__control`}>
                            <SelectItem
                                handleChange = {this.setPosition.bind(this)}
                                validate = {this.props.validateParts ? this.state.validFields.positions : true}
                                options = {this.state.options.positions} placeholder={'Расположение'}
                            />
                        </div>
                    </div>
                    :
                    <></>
                    
                }

                {
                    this.state.options.secondMaterial.length > 0 ? 
                    <div className="modal-window__controls">
                        <div className='modal-window__control'>
                            <SelectMaterial handleChange = {this.setSecondMaterial.bind(this)} validate={this.props.validateParts ? this.state.validFields.secondMaterial : true} options = {this.state.options.secondMaterial} placeholder={'Второй материал'}/>
                        </div>
                        <div className={`modal-window__control ${this.state.currentOptions.secondMaterial === '' ? 'modal-window__control--disabled' : ''} `}>
                            <SelectMaterial name ="color" handleChange = {this.setSecondColor.bind(this)} validate={this.props.validateParts ? this.state.validFields.secondColor : true} options = {this.state.options.secondColor} placeholder={'Второй цвет'}/>
                        </div>
                    </div>
                    : 
                    <></>
                }
            </>
        )
    }
}
